"use strict";

import { changeURL, initStateFromUrl } from "./customFunctions/paramsURL";

export const BACKGROUND_COLOR = 0xffffff;
export const ENVIRONMENT_MAP = "public/environment/lilienstein_1k.hdr";
export const ENVIRONMENT_MAP_INTENSITY = 0.6
export const SHADOW_TRANSPARENCY = 0.2;
export const TONE_MAPPING_EXPOSURE = 1.0;

export const settingsLouver = {
  countLouver: 0,
  width: 0,
  correction: 0,
  morphValueOrigin: 0,
};

export const log = false;
export let pdfImg = { img: "" };
export let pdfImgTop = { img: "" };

//#region URL AND STATE
let isBatchUpdating = false;
const delay = 100;

function triggerCallback() {
  if (isBatchUpdating) {
    return;
  }

  isBatchUpdating = true;

  setTimeout(() => {
    changeURL();
    isBatchUpdating = false;
  }, delay);
}

function createNestedProxy(target) {
  return new Proxy(target, {
    set(target, key, value) {
      target[key] = value;

      triggerCallback();

      return true;
    },

    get(target, key) {
      const value = target[key];
      if (typeof value === "object" && value !== null) {
        if (value instanceof Set) {
          return createSetProxy(value); // STATE PARAM === SET
        } else if (Array.isArray(value)) {
          return createArrayProxy(value); // STATE PARAM === ARRAY
        } else {
          return createNestedProxy(value); // STATE PARAM === ...
        }
      }
      return value;
    },
  });
}

function createSetProxy(set) {
  //DESCRIPTION OWN METHOD FOR PROXY COVER
  return new Proxy(set, {
    get(target, prop) {
      if (prop === "add") {
        return (value) => {
          target.add(value);
          triggerCallback();
          return target;
        };
      }

      if (prop === "delete") {
        return (value) => {
          const result = target.delete(value);
          triggerCallback();
          return result;
        };
      }

      if (prop === "clear") {
        return () => {
          target.clear();
          triggerCallback();
        };
      }

      if (prop === "has") {
        return (value) => {
          const result = target.has(value);
          triggerCallback();
          return result;
        };
      }

      if (prop === "forEach") {
        return (...args) => {
          target.forEach(...args);
          triggerCallback();
        };
      }

      if (prop === "from") {
        return (iterable) => {
          const newSet = Set.from(iterable);
          triggerCallback();
          return newSet;
        };
      }

      // if (prop === "values") {
      //   return () => {
      //     const result = Set.prototype.values.call(target);
      //     triggerCallback();
      //     return result;
      //   };
      // }

      if (prop === "values" || prop === Symbol.iterator) {
        return () => {
          const iterator = target[Symbol.iterator](); // Використовуємо стандартний ітератор
          triggerCallback();
          return iterator;
        };
      }

      return target[prop];
    },

    set(target, prop, value) {
      target[prop] = value;
      triggerCallback();
      return true;
    },
  });
}

function createArrayProxy(array) {
  return new Proxy(array, {
    set(target, key, value) {
      target[key] = value;

      triggerCallback();

      return true;
    },
    get(target, key) {
      if (
        key === "push" ||
        key === "pop" ||
        key === "shift" ||
        key === "unshift" ||
        key === "splice" ||
        key === "filter"
      ) {
        return (...args) => {
          const result = Array.prototype[key].apply(target, args);
          triggerCallback();
          return result;
        };
      }
      return target[key];
    },
  });
}

export const stateForProxy = {
  typePergola: 0,
  roofType: 0,
  retractOption: 'oneSide',
  louvreType: 0,
  postSize: 0,
  currentRotationZ: 30,
  isRotated: false,
  height: 2,
  length: 2,
  width: 4,
  backWall: false,
  electro: new Set(),
  subSystem: new Set(),
  subSystemUrl: new Set(),
  currentSubSystem: [],
  colorRoof: "#3A3A3A",
  colorBody: "#3A3A3A",
  colorSladditec: "#3A3A3A",
  colorShutters: "#3A3A3A",
  colorZip: "#3A3A3A",
  pdfMode: false,
  portalOption: 0,
  dayMode: true,
  
  louverInterval: 16.5,
  directionRoof: 0,
  roofColorType: 0,
  postDepthInterval: 23.5,
  currentActiveSystems: null,
  imgForPdf: null,
  wallOption: false,
  recessedLighting: 4,
  heaters: false,
  moodLight: false,
  ledLights: false,
  lightingEnabled: false,
  slatsSize: false,
  lastSpan: null,
  zipInput: 20,
  slidingDoorInput: 35,
  louversOpeningInput: 0,
  type3Dmodel: 0,
  slidingShuttersInput: 30,
  slidingShuttersRotate: 0,
  slidingFixShuttersRotate: 0,
  biFoldDoorShattersInput: 0,
  biFoldDoorShattersRotate: 0,
  midPointForScreenZ: 0,
  midPointForScreenX: 0,
  transparency: "10",
  postWidthInterval: 23.5,
};

export const state = new Proxy(stateForProxy, {
  get(target, key) {
    const value = target[key];
    if (key === "currentActiveSystems") {
      // console.log(value);
    }
    if (typeof value === "object" && value !== null) {
      if (value instanceof Set) {
        return createSetProxy(value); // COVER FOR SET
      } else if (Array.isArray(value)) {
        return createArrayProxy(value); // COVER FOR ARRAY
      } else {
        return createNestedProxy(value); // COVER FOR ANOTHER ...
      }
    }
    return value;
  },

  set(target, key, value) {
    target[key] = value;

    triggerCallback();

    return true;
  },
});

window.state = state;

await initStateFromUrl();
//#endregion

export const MODEL_PATHS = ["public/models/Louvretec.glb"];

export const MODEL_CENTER_POSITION = -1;

export const DATA_CONCTRUCTION = {
  widthToPillar: 44, // inch
  depthToPillar: 24, // inch
  roofGlassWidthMin: 100 / 2.54, // inch
  roofGlassWidthMax: 150 / 2.54, // inch
};

export const MORPH_DATA = {
  width: {
    min: 1,
    max: 12,
    initValue: state.width,
  },
  length: {
    min: 1,
    max: 5,
    initValue: state.length,
  },
  height: {
    min: 1.0,
    max: 3.5,
    initValue: state.height,
  },
  opening: {
    width: { min: 1, max: 12 },
    length: { min: 1, max: 5 },
  },
  retractable: {
    width: { min: 2, max: 7 },
    length: { min: 2, max: 5 },
  },
};

export function getDimensionLimits(roofType) {
  return roofType === 0 ? MORPH_DATA.opening : MORPH_DATA.retractable;
}

export const HEIGHT_MORPH_MAP = {
  1.0: 0.333,
  1.5: 0.500,
  2.0: 0.667,
  2.5: 0.733,
  3.0: 0.833,
  3.5: 1.000,
};

export function getHeightMorph(height) {
  if (HEIGHT_MORPH_MAP[height] !== undefined) return HEIGHT_MORPH_MAP[height];
  const keys = Object.keys(HEIGHT_MORPH_MAP).map(Number).sort((a, b) => a - b);
  for (let i = 0; i < keys.length - 1; i++) {
    if (height >= keys[i] && height <= keys[i + 1]) {
      const t = (height - keys[i]) / (keys[i + 1] - keys[i]);
      return HEIGHT_MORPH_MAP[keys[i]] + t * (HEIGHT_MORPH_MAP[keys[i + 1]] - HEIGHT_MORPH_MAP[keys[i]]);
    }
  }
  return 1.0;
}

// walls` morphs:

export const WIDTH_MORPH_MAP = {
  1: 0.000,
  2: 0.091,
  3: 0.182,
  4: 0.273,
  5: 0.364,
  6: 0.455,
  7: 0.545,
  8: 0.636,
  9: 0.727,
  10: 0.818,
  11: 0.909,
  12: 1.000,
};

export const LENGTH_MORPH_MAP = {
  1: 0.000,
  2: 0.250,
  3: 0.500,
  4: 0.750,
  5: 1.000,
};

export function getWidthMorph(width) {
  if (WIDTH_MORPH_MAP[width] !== undefined) return WIDTH_MORPH_MAP[width];
  // interpolate
  const keys = Object.keys(WIDTH_MORPH_MAP).map(Number).sort((a, b) => a - b);
  for (let i = 0; i < keys.length - 1; i++) {
    if (width >= keys[i] && width <= keys[i + 1]) {
      const t = (width - keys[i]) / (keys[i + 1] - keys[i]);
      return WIDTH_MORPH_MAP[keys[i]] + t * (WIDTH_MORPH_MAP[keys[i + 1]] - WIDTH_MORPH_MAP[keys[i]]);
    }
  }
  return 1.0;
}

export function getLengthMorph(length) {
  if (LENGTH_MORPH_MAP[length] !== undefined) return LENGTH_MORPH_MAP[length];
  const keys = Object.keys(LENGTH_MORPH_MAP).map(Number).sort((a, b) => a - b);
  for (let i = 0; i < keys.length - 1; i++) {
    if (length >= keys[i] && length <= keys[i + 1]) {
      const t = (length - keys[i]) / (keys[i + 1] - keys[i]);
      return LENGTH_MORPH_MAP[keys[i]] + t * (LENGTH_MORPH_MAP[keys[i + 1]] - LENGTH_MORPH_MAP[keys[i]]);
    }
  }
  return 1.0;
}

// lenth_frame_x morph for 150×150 retractable central posts (FC/BC):
export const LENTH_FRAME_X_150_MORPH_MAP = {
  2: 0.000,
  3: -0.100,
  4: -0.200,
  5: -0.300,
};

export function getLenthFrameX150Morph(length) {
  if (LENTH_FRAME_X_150_MORPH_MAP[length] !== undefined) return LENTH_FRAME_X_150_MORPH_MAP[length];
  const keys = Object.keys(LENTH_FRAME_X_150_MORPH_MAP).map(Number).sort((a, b) => a - b);
  for (let i = 0; i < keys.length - 1; i++) {
    if (length >= keys[i] && length <= keys[i + 1]) {
      const t = (length - keys[i]) / (keys[i + 1] - keys[i]);
      return LENTH_FRAME_X_150_MORPH_MAP[keys[i]] + t * (LENTH_FRAME_X_150_MORPH_MAP[keys[i + 1]] - LENTH_FRAME_X_150_MORPH_MAP[keys[i]]);
    }
  }
  return 0.5;
}


export const DOOR_HEIGHT_MORPH_MAP = {
  1.0: 0.250,
  1.5: 0.500,
  2.0: 0.750,
  2.5: 0.850,
  3.0: 1.000,
  3.5: 1.000,
};


export function getDoorHeightMorph(height) {
  if (DOOR_HEIGHT_MORPH_MAP[height] !== undefined) return DOOR_HEIGHT_MORPH_MAP[height];
  // Interpolate
  const keys = Object.keys(DOOR_HEIGHT_MORPH_MAP).map(Number).sort((a, b) => a - b);
  for (let i = 0; i < keys.length - 1; i++) {
    if (height >= keys[i] && height <= keys[i + 1]) {
      const t = (height - keys[i]) / (keys[i + 1] - keys[i]);
      return DOOR_HEIGHT_MORPH_MAP[keys[i]] + t * (DOOR_HEIGHT_MORPH_MAP[keys[i + 1]] - DOOR_HEIGHT_MORPH_MAP[keys[i]]);
    }
  }
  return 1.0;
}

export function getDoorFrameWidthMorph(width) {
  const t = width * 0.2083333333 - 0.25;
  return Math.max(0, Math.min(1, t));
}

export function getDoorPanelWidthMorph(panelWidth) {
  if (panelWidth <= 0.75) return 0.0;
  if (panelWidth >= 1.2) return 1.0;
  if (panelWidth <= 1.0) {
    return ((panelWidth - 0.75) / 0.25) * 0.55;
  }
  return 0.55 + ((panelWidth - 1.0) / 0.2) * 0.40;
}

export const getShutterFrameWidthMorph = (spanMeters) => {
  const minSpan = 1;
  const maxSpan = 10;
  return Math.max(0, Math.min(1, (spanMeters - minSpan) / (maxSpan - minSpan)));
};


export const getLouverWidthMorph = (panelWidthMeters) => {
  const minWidth = 0.321;
  const maxWidth = 1.8;
  return Math.max(0, Math.min(1, (panelWidthMeters - minWidth) / (maxWidth - minWidth)));
};

export const getShutterPanelWidthMorph = (panelWidthMeters) => {
  const minWidth = 0.5;
  const maxWidth = 1.5;
  return Math.max(0, Math.min(1, (panelWidthMeters - minWidth) / (maxWidth - minWidth)));
};

// Louver blades inside shutter panels — slightly narrower than the panel frame.
// Uses the same range as getShutterPanelWidthMorph with a small inset,
// giving values bigger than getLouverWidthMorph (0.321–1.8 range) but
// slightly less than the full panel morph.
export const getShutterLouverWidthMorph = (panelWidthMeters) => {
  const louverWidth = panelWidthMeters - 0.05; // 5 cm inset inside panel frame
  const minWidth = 0.5;
  const maxWidth = 1.5;
  return Math.max(0, Math.min(1, (louverWidth - minWidth) / (maxWidth - minWidth)));
};

export const SHUTTER_TRACK_HEIGHT_MORPH_MAP = {
  1.0: 0.40,
  1.5: 0.60,
  2.0: 0.80,
  2.5: 0.88,
  3.0: 1.00,
  3.5: 1.00,
};

export function getShutterTrackHeightMorph(height) {
  if (SHUTTER_TRACK_HEIGHT_MORPH_MAP[height] !== undefined) return SHUTTER_TRACK_HEIGHT_MORPH_MAP[height];
  const keys = Object.keys(SHUTTER_TRACK_HEIGHT_MORPH_MAP).map(Number).sort((a, b) => a - b);
  for (let i = 0; i < keys.length - 1; i++) {
    if (height >= keys[i] && height <= keys[i + 1]) {
      const t = (height - keys[i]) / (keys[i + 1] - keys[i]);
      return SHUTTER_TRACK_HEIGHT_MORPH_MAP[keys[i]] + t * (SHUTTER_TRACK_HEIGHT_MORPH_MAP[keys[i + 1]] - SHUTTER_TRACK_HEIGHT_MORPH_MAP[keys[i]]);
    }
  }
  return 1.0;
}

export const SHADE_HEIGHT_MORPH_MAP = {
  1.0: 0.22,
  1.5: 0.40,
  2.0: 0.62,
  2.5: 0.70,
  3.0: 0.82,
  3.5: 1.00,
};

export function getShadeHeightMorph(height) {
  if (SHADE_HEIGHT_MORPH_MAP[height] !== undefined) return SHADE_HEIGHT_MORPH_MAP[height];
  const keys = Object.keys(SHADE_HEIGHT_MORPH_MAP).map(Number).sort((a, b) => a - b);
  for (let i = 0; i < keys.length - 1; i++) {
    if (height >= keys[i] && height <= keys[i + 1]) {
      const t = (height - keys[i]) / (keys[i + 1] - keys[i]);
      return SHADE_HEIGHT_MORPH_MAP[keys[i]] + t * (SHADE_HEIGHT_MORPH_MAP[keys[i + 1]] - SHADE_HEIGHT_MORPH_MAP[keys[i]]);
    }
  }
  return 1.0;
}

export const SHADE_CLOSING_SCALE_MAP = {
  1.0: 0.40,
  1.5: 0.54,
  2.0: 0.71,
  2.5: 0.77,
  3.0: 0.86,
  3.5: 1.00,
};

export function getShadeClosingScale(height) {
  if (SHADE_CLOSING_SCALE_MAP[height] !== undefined) return SHADE_CLOSING_SCALE_MAP[height];
  const keys = Object.keys(SHADE_CLOSING_SCALE_MAP).map(Number).sort((a, b) => a - b);
  for (let i = 0; i < keys.length - 1; i++) {
    if (height >= keys[i] && height <= keys[i + 1]) {
      const t = (height - keys[i]) / (keys[i + 1] - keys[i]);
      return SHADE_CLOSING_SCALE_MAP[keys[i]] + t * (SHADE_CLOSING_SCALE_MAP[keys[i + 1]] - SHADE_CLOSING_SCALE_MAP[keys[i]]);
    }
  }
  return 1.0;
}


export const MORPH_DATA_SI = {
  width: {
    min: 1.21,
    max: 12.1844,
  },
  length: {
    min: 1.21,
    max: 12.1844,
  },
  height: {
    min: 2.65,
    max: 4.57,
  },
  frameWidth: {
    min: 1.21,
    max: 18.28,
  },
  frameLength: {
    min: 1.21,
    max: 18.28,
  },
  louverLength: {
    min: 1.67,
    max: 4.26,
  },
};

export const WALL_OFFSETS = {
  height_8: {
    sideWallOffsetY: 0,
    backWallOffsetY: 0,
  },
  height_9: {
    sideWallOffsetY: 0.0217,
    backWallOffsetY: 0.4015,
  },
  height_10: {
    sideWallOffsetY: 0.045,
    backWallOffsetY: 0.4965,
  },
  height_11: {
    sideWallOffsetY: 0.067,
    backWallOffsetY: 0.513,
  },
  height_12: {
    sideWallOffsetY: 0.09,
    backWallOffsetY: 0.5315,
  },
  height_13: {
    sideWallOffsetY: 0.035,
    backWallOffsetY: 0.5485,
  },
  height_14: {
    sideWallOffsetY: 0.0575,
    backWallOffsetY: 0.566,
  },
  height_15: {
    sideWallOffsetY: 0.0035,
    backWallOffsetY: 0.2,
  },
};

console.log(state);
